import { CustomCondition } from '@cstweb/commercetools-client'

/**
 *  This mapping is for WEBP-9566 hardcoded custom conditions. Conditions
 * are then mapped to each selected target per productNumber.
 *
 * Main usage is for overriding regular algorithm & rules for assigning colors in
 * paneldesgin.
 *
 * TODO: Remove after real implementation is created
 */

export const HARDCODED_CUSTOM_CONDITIONS: Record<string, CustomCondition[]> = {
  45747: [
    {
      targetName: 'PD-L1',
      types: [
        { imaging: true, name: '488' },
        { imaging: true, name: '594' },
        { imaging: false, name: '647' },
        { imaging: false, name: '750' },
      ],
    },
  ],
  19166: [
    {
      targetName: 'PD-L1',
      types: [
        { imaging: true, name: '488' },
        { imaging: true, name: '594' },
        { imaging: false, name: '647' },
        { imaging: false, name: '750' },
      ],
    },
  ],
  62750: [
    {
      targetName: 'PD-L1',
      types: [
        { imaging: true, name: '488' },
        { imaging: true, name: '594' },
        { imaging: false, name: '647' },
        { imaging: false, name: '750' },
      ],
    },
  ],
  66676: [
    {
      targetName: 'PD-L1',
      types: [
        { imaging: true, name: '488' },
        { imaging: true, name: '594' },
        { imaging: false, name: '647' },
        { imaging: false, name: '750' },
      ],
    },
  ],
}
